// extracted by mini-css-extract-plugin
export default {"parentContainer":"textarea_parentContainer__ma-al","parent":"textarea_parent__UQbms"};